import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../layouts/Header";
import { loader_image } from "../_components/Imagepath";
import {  base_url,Apitoken, Authtoken } from "../Global";
import PropTypes from 'prop-types';
// import $ from "jquery";
import $ from "jquery";

import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {MaterialReactTable} from 'material-react-table';
import Swal from 'sweetalert2';
//Material UI Imports
// import {
//   MenuItem,
// } from '@mui/material';

const DecaySale = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [dataoverview, setDataoverview] = useState({});
    const [permission, setPermission] = useState({});
  
  // const [backendSuccess, setBackendSuccess] = useState(null);
  // const [backendErrors, setBackendErrors] = useState(null);
  // const [statusOptions, setStatusOptions] = useState([]);

  const [groupbycustomer, setGroupbycustomer] = useState([]);
  const [groupbydate, setGroupbydate] = useState([]);
 let season_id = localStorage.getItem("season_id");
  //let para ={season_id:season_id};
  const [formData, setFormData] = useState({
    season_id:season_id,
    start_date:'',
    end_date:'',
    customer:'',
    
  });

  // const [totalopenamount, setTotalopenamount] = useState(0);

  
  
    const statusOptions =[
 
      {
        "id": 0,
        "title": "PENDING",
        "color": "white",
        "bg_color": "red",
    },
    {
      "id":1,
      "title": "PAID",
      "color": "white",
      "bg_color": "green",
  },
 
    ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
 axios.post("/decay-sales/listing",formData,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
       
        if (response.data.code === 200) {
           setGroupbycustomer(response.data.data.groupby_customer);       
          setGroupbydate(response.data.data.groupby_date);   
        }
        else  if (response.data.code === 401) {
          window.location.href = "/login";
        }else{
          window.location.href = "/login"; 
        }
      })
      .catch((error) => {
        console.log(error);
      });


      axios.post("/decay-sales/listing-price",formData,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
       
        if (response.data.code === 200) {
          setData(response.data.data.sales);
        }
        else  if (response.data.code === 401) {
          window.location.href = "/login";
        }else{
          window.location.href = "/login"; 
        }
      })
      .catch((error) => {
        console.log(error);
      });
            
      axios.post("/decay-sales/listing-overview",formData,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
         if (response.data.code === 200) {
            setDataoverview(response.data.data.overview);
         }
        else  if (response.data.code === 401) {
          window.location.href = "/login";
        }else{
          window.location.href = "/login"; 
        }
      })
      .catch((error) => {
        console.log(error);
      });
  
  
  }
  useEffect(() => {
        setPermission(FindModuleById(281)); 
console.log(permission);



    axios.post("/decay-sales/listing",formData,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
       
        if (response.data.code === 200) {
           setGroupbycustomer(response.data.data.groupby_customer);       
          setGroupbydate(response.data.data.groupby_date);   
        }
        else  if (response.data.code === 401) {
          window.location.href = "/login";
        }else{
          window.location.href = "/login"; 
        }
      })
      .catch((error) => {
        console.log(error);
      });


      axios.post("/decay-sales/listing-price",formData,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
       
        if (response.data.code === 200) {
          setData(response.data.data.sales);
        }
        else  if (response.data.code === 401) {
          window.location.href = "/login";
        }else{
          window.location.href = "/login"; 
        }
      })
      .catch((error) => {
        console.log(error);
      });
            
      axios.post("/decay-sales/listing-overview",formData,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
         if (response.data.code === 200) {
            setDataoverview(response.data.data.overview);
         }
        else  if (response.data.code === 401) {
          window.location.href = "/login";
        }else{
          window.location.href = "/login"; 
        }
      })
      .catch((error) => {
        console.log(error);
      });



  }, []);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };




const InvoiceNumberCell = ({ row }) => (
  <a href={`/decay-sales-view/${row.original.id}`} className="">
    {row.original.invoice_number}
  </a>
);

InvoiceNumberCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      invoice_number: PropTypes.string.isRequired,
    }),
  }).isRequired,
};
const TotalQuantityCell = ({ row }) => {
  const total_decay = row.original.items || [];
  const totalNetWeight = total_decay.reduce((sum, item) => sum + (item.quantity || 0), 0);
  return <span>{totalNetWeight}</span>;
};

TotalQuantityCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      items: PropTypes.arrayOf(
        PropTypes.shape({
          quantity: PropTypes.number,
        })
      ),
    }),
  }).isRequired,
};

const PaymentStatusCell = ({ row }) => (
  <div className="btn-group custom-table-btn-group">
    <button
      type="button"
      className="btn btn-block dropdown-toggle me-1"
      id={`status-production-${row.original.id}`}
      style={{
        backgroundColor: row.original.status?.bg_color || 'transparent',
        color: row.original.status?.color || 'black',
      }}
      data-bs-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      {row.original.status?.title || ''}
    </button>
    <div className="dropdown-menu">
      {statusOptions &&
        statusOptions.map((shipp) => (
          <button
            key={shipp.id}
            className="dropdown-item btn btn-block"
            style={{ backgroundColor: shipp.bg_color, color: shipp.color }}
            onClick={() => changeOrderStatus(row.original.id, shipp.id, 'all')}
          >
            {shipp.title}
          </button>
        ))}
    </div>
  </div>
);

PaymentStatusCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      status: PropTypes.shape({
        title: PropTypes.string,
        bg_color: PropTypes.string,
        color: PropTypes.string,
      }),
    }),
  }).isRequired,
};

const PriceCell = ({ row }) => {        
    // const total_items = row.original.items || []; // Ensure it's an array

    // console.log(total_items);
    // const calibreDisplay = total_items.map(item => item.price).join(' / ');
  
    // return <span>{calibreDisplay}</span>;
     const total_items = Array.isArray(row.original.items) ? row.original.items : [];

    // Get all unique prices
    const uniquePrices = [...new Set(total_items.map(item => item.price))];

    // If all prices are same → show one, else show all joined by /
    const priceDisplay =
      uniquePrices.length === 1
        ? uniquePrices[0]
        : uniquePrices.join(" / ");

    return <span>{priceDisplay || "N/A"}</span>;
  };
  
  PriceCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        items: PropTypes.arrayOf(
          PropTypes.shape({
            price: PropTypes.string
          })
        )
      }).isRequired
    }).isRequired
  };


  
const quantityCell = ({ row }) => {        
        const total_items = row.original.items || []; // Ensure it's an array
       const totalquantity = total_items
         .reduce((sum, item) => sum + (item.quantity || 0), 0);
     return <span>{totalquantity}</span>;
  };
  
  quantityCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        items: PropTypes.arrayOf(
          PropTypes.shape({
            quantity: PropTypes.string
          })
        )
      }).isRequired
    }).isRequired
  };
const columns = [
  {
    header: 'Invoice Number',
    accessorFn: (row) => `${row.invoice_number}`,
    Cell: InvoiceNumberCell,
  },
  {
    accessorKey: 'date', 
    header: 'Date',
  },
  {
    header: 'Customer',
    accessorFn: (row) => (row.customer ? row.customer.name : ''),
  },
  // {
  //   header: 'Total Quantity',
  //   accessorFn: (row) => row.quantity || 0,
  // },

     {
      header: 'Total Quantity',
      Cell: quantityCell
    },
     {
      header: 'Price',
      Cell: PriceCell
    },

  //  {
  //   header: 'Price',
  //   accessorFn: (row) => row.price || 0,
  // },
  {
    accessorKey: 'total_price',
    header: 'Total Amount',
  },
  
  // {
  //   header: 'Payment Status',
  //   accessorFn: (row) => row.status?.title || '',
  //   Cell: PaymentStatusCell,
  // },
  {
    header: 'Payment Method',
    accessorFn: (row) => row.method?.title || '',
  },
  {
    header: 'Created By',
    accessorFn: (row) =>
      row.createdby ? `${row.createdby.first_name} ${row.createdby.last_name}` : '',
  },
  {
    header: 'Updated By',
    accessorFn: (row) =>
      row.updatedby ? `${row.updatedby.first_name} ${row.updatedby.last_name}` : '',
  },
];


// 🔹 Separate Cell Component for "Date" (Fixes Unused renderedCellValue)
const DateCell = ({ row }) => (
  <a href={`/decay-sales-date/${row.original.date}`} className="">
    {row.original.date}
  </a>
);

// ✅ Define PropTypes
DateCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      date: PropTypes.string.isRequired, // Assuming date is a string
    }),
  }).isRequired,
};

// 🔹 Column Configuration
const columns_date = [
  {
    header: 'Date',
    accessorKey: 'date', // <-- This enables filtering/sorting

    Cell: DateCell, // ✅ Use separate component
  },
  {
    accessorKey: 'total_quantity',
    header: 'Quantity',
  },
  {
    accessorKey: 'customer_total_price',
    header: 'Total Amount',
  },
  {
    accessorKey: 'total_entries',
    header: 'Operations',
  },
];



// 🔹 Total Paid Amount Cell
const TotalPaidAmountCell = ({ row }) => {
  const totalPaid = row.original.customer_paid_amount?.total_cost || 0;
  return <span>{totalPaid}</span>;
};

TotalPaidAmountCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      customer_paid_amount: PropTypes.shape({
        total_cost: PropTypes.number,
      }),
    }),
  }).isRequired,
};

// 🔹 Open Amount Cell
const OpenAmountCell = ({ row }) => {
  const totalPrice = row.original.customer_total_price || 0;
  const totalPaid = row.original.customer_paid_amount?.total_cost || 0;
  return <span>{totalPrice - totalPaid}</span>;
};

OpenAmountCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      customer_total_price: PropTypes.number,
      customer_paid_amount: PropTypes.shape({
        total_cost: PropTypes.number,
      }),
    }),
  }).isRequired,
};

// 🔹 Column Configuration


const showCustomerName = ({ row }) => (
  <a href={`/decay-sales-customer/${row.original.customer_id}`} className="">
    {row.original.customer_name}
  </a>
);

showCustomerName.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      customer_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      customer_name: PropTypes.string.isRequired,
    }),
  }).isRequired,
};
const columnscustomer = [

  {
    header: 'Customer',
    accessorFn: (row) => `${row.customer_name}`,
    Cell: showCustomerName,
  },
  {
    accessorKey: 'customer_total_price',
    header: 'Total Amount',
  },
  {
    header: 'Total Paid Amount',
    accessorFn: (row) => row.customer_paid_amount?.total_cost || 0, // <-- Add this

    Cell: TotalPaidAmountCell, // ✅ Use separate component
  },
  // {
  //   header: 'Open Amount',
  //   Cell: OpenAmountCell, // ✅ Use separate component
  // },
  {
    header: 'Open Amount',
    accessorFn: (row) => {
      const total = row.customer_total_price || 0;
      const paid = row.customer_paid_amount?.total_cost || 0;
      return total - paid;
    },
    Cell: OpenAmountCell,
  },
  {
    accessorKey: 'total_quantity',
    header: 'Quantity',
  },
  {
    accessorKey: 'total_entries',
    header: 'Operations',
  },
];


  

  const changeOrderStatus = (user_id, status,type) =>{

    Swal.fire({
      title: 'Do you want Change Status?',
      //text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'green',
      cancelButtonColor: '#d33',
      confirmButtonText: 'CONFIRM',
      customClass: "swal-orders"
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/decay-sales/change-status/${season_id+'-'+user_id}/${status}`, {headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
            .then((response) => {
              console.log(response.data.data.paymentstatus);
              if (response.data.code === 200) {
                $("#status-"+type+"-"+user_id).text(response.data.data.paymentstatus.title);
                $("#status-"+type+"-"+user_id).css('background-color',response.data.data.paymentstatus.bg_color);
                $("#status-"+type+"-"+user_id).css('color',response.data.data.paymentstatus.color);

                
                axios.post("/decay-sales/listing-price",formData,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
                .then((response) => {
                 
                  if (response.data.code === 200) {
                    setData(response.data.data.sales);
          
                  }
                  else  if (response.data.code === 401) {
                    window.location.href = "/login";
                  }else{
                    window.location.href = "/login"; 
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
                axios.post("/decay-sales/listing",formData,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
                .then((response) => {
                 
                  if (response.data.code === 200) {
                    //setData(response.data.data.sales);
                    //setDataoverview(response.data.data.overview);
                    setGroupbycustomer(response.data.data.groupby_customer);       
                    setGroupbydate(response.data.data.groupby_date);   
            
            
                    // let totalamount = response.data.data.overview.sum_total_price;
                    // //let paid_total = response.data.data.overview.paid_total;
                    
                    // let payment_amount = (response.data.data.payments && response.data.data.payments.total_cost)
                    // ? response.data.data.payments.total_cost
                    // : 0;
                    
                    // let all_paid = (payment_amount);
                
                    // setTotalopenamount(totalamount -all_paid );  
                    axios.post("/decay-sales/listing-overview",formData,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
                    .then((response) => {
                       if (response.data.code === 200) {
                          setDataoverview(response.data.data.overview);
                       }
                      else  if (response.data.code === 401) {
                        window.location.href = "/login";
                      }else{
                        window.location.href = "/login"; 
                      }
                    })
                    .catch((error) => {
                      console.log(error);
                    });
                  }
                  else  if (response.data.code === 401) {
                    window.location.href = "/login";
                  }else{
                    window.location.href = "/login"; 
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
                
                Swal.fire(
                  'Success!',
                  'Payment Status has been changed Successfully.',
                  'success'
                );
                // setTimeout(() => {
                //  // window.location.href = "/orders";
                // }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            }); 
           }
    });
  }

  function objectToQueryString(obj) {
    return Object.keys(obj)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
        .join('&');
}
  const downloadExcel = (e) => {

    console.log(e);
   
    const queryString = objectToQueryString(formData);
 
     window.open(`${base_url}/decay-sales/listing-excel?${queryString}`, '_blank');

  }

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Decay Sale</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Decay Sale</li>
                </ul>
              </div>
              <div className="col-auto">
              {/* &nbsp;&nbsp;
                  <a
                    className="btn btn-primary filter-btn"
                    href="/decay-sales#"
                    id="filter_search"
                  >
                    <i className="fas fa-filter"></i>
                  </a> */}
                  {/* &nbsp;&nbsp;
                   {permission && permission.add == 1 && (
                                   <Link to="/decay-sales-add" className="btn btn-primary me-1">
                                   <i className="fas fa-plus"></i>
                                 </Link>
                               
                                  )}  */}

                  &nbsp;&nbsp;
                
                  <button
                    className="btn btn-primary"
                    onClick={() => downloadExcel()}
                  >
                    <i className="fa fa-file-excel-o"></i>  <i className="fa fa-download"></i><img id="loader-image2" className="loader-image2 loader-hide2" src={loader_image}/>
                  </button> 
              </div>
            </div>
          </div>

          <div id="filter_inputs2" className="card filter-card2">
              <div className="card-body pb-0">
                <form onSubmit={handleSubmit}>
                <div className="row">

                <div className="col-md-2">
                    <div className="form-group">
                      <label>Sart Date:</label>
                      <input type="date" name="start_date" className="form-control"  value={formData.start_date} onChange={(e) => {
                                handleChange(e);
                              }}  />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>End Date:</label>
                      <input type="date" name="end_date" className="form-control"  value={formData.end_date} onChange={(e) => {
                                handleChange(e);
                              }}  />
                    </div>
                  </div>
                
                
                  <div className="col-md-2">
                    <div className="pt-4 mt-2">
                      <button type="submit" className="btn btn-primary">
                        Filter
                      </button>
                      &nbsp;&nbsp;
                      <a href="/decay-sales" className="btn btn-primary me-1"><i className="fa fa-times"></i></a>
                 
                    </div>
                  </div>
                </div>
                </form>
                
              </div>
            </div>
            {permission && permission.list == 1 && (
             <div className="row">  
              
             <div className="row">
          
                        <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                          <div className="card inovices-card w-100">
                            <div className="card-body">
                              <div className="dash-widget-header">
                                <div className="dash-count text-center">
                                  <div className="dash-title"> Average Price</div>
                                  <div className="dash-counts">
                                    <p>{dataoverview.average_price}dh</p>
                                  </div>
                                </div>
                              </div>
                            
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                          <div className="card inovices-card w-100">
                            <div className="card-body">
                              <div className="dash-widget-header">
                                <div className="dash-count text-center">
                                  <div className="dash-title"> Total Sales</div>
                                  <div className="dash-counts">
                                  <p>{dataoverview.sum_total_price ? dataoverview.sum_total_price.toFixed(2) : "0.00"}dh</p>
                                  </div>
                                </div>
                              </div>
                            
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                          <div className="card inovices-card w-100">
                            <div className="card-body">
                              <div className="dash-widget-header">
                                <div className="dash-count text-center">
                                  <div className="dash-title"> Total Quanity </div>
                                  <div className="dash-counts">
                                    <p>{dataoverview.sum_total_quantity}KG</p>
                                  </div>
                                </div>
                              </div>
                            
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                          <div className="card inovices-card w-100">
                            <div className="card-body">
                              <div className="dash-widget-header">
                                <div className="dash-count text-center">
                                  <div className="dash-title">  Total Payments  </div>
                                  <div className="dash-counts">
                                    <p>{dataoverview.paid_amount}dh</p>
                                  </div>
                                </div>
                              </div>
                            
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                          <div className="card inovices-card w-100">
                            <div className="card-body">
                              <div className="dash-widget-header">
                                <div className="dash-count text-center">
                                  <div className="dash-title"> Open Amount </div>
                                  <div className="dash-counts">
                                    <p>{dataoverview.open_amount}dh</p>
                                  </div>
                                </div>
                              </div>
                            
                            </div>
                          </div>
                        </div>
                              
                        </div>


                  

                    <section className="comp-section">
                        <div className="row">
                        <div className="col-md-12">
                            <div className="card bg-white">
                            
                            <div className="card-body">
                                <ul className="nav nav-tabs nav-tabs-bottom">
                                
                                <li className="nav-item">
                                    <a className="nav-link active" href="#listing-groupby" data-bs-toggle="tab">Decay Sales by  Date</a>                                  
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="#listing-groupby-supplier" data-bs-toggle="tab">Decay Sales by Customer</a>                                  
                                </li>
                                <li className="nav-item" >
                                    <a className="nav-link" href="#listing-all" data-bs-toggle="tab"> Decay Sales</a>                                   
                                </li>                    
                                </ul>
                                <div className="tab-content">
                                <div className="tab-pane show active" id="listing-groupby">
                                    <div className="row"  id="listing-followup-groupby" >
                                      <div className="col-sm-12" >
                                      <div className="card card-table">
                                        <div className="card-body">
                                          <div className="table-responsive">
                                          <MaterialReactTable columns={columns_date} data={groupbydate} 
                                              enableColumnOrdering
                                              enablePinning
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="tab-pane " id="listing-groupby-supplier">
                                <div className="row"   id="listing-followup">
                                  <div className="col-sm-12">
                                    <div className="card card-table">
                                      <div className="card-body">
                                          <div className="table-responsive">

                                          <MaterialReactTable columns={columnscustomer} data={groupbycustomer} 
                                              enableColumnOrdering
                                              enablePinning
                                            />
                                          </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                  
                                  </div>                                
                                  <div className="tab-pane " id="listing-all">
                                <div className="row"   id="listing-followup">
                                  <div className="col-sm-12">
                                    <div className="card card-table">
                                      <div className="card-body">
                                          <div className="table-responsive">

                                          <MaterialReactTable columns={columns} data={data} 
                      
                                                        enableColumnOrdering
                                              
                                                        enablePinning
                                                        //enableRowActions
                                                      // renderRowActionMenuItems={({ row }) => [
                                                      //     permission?.update == 1 && (
                                                      //       <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                                      //         Edit
                                                      //       </MenuItem>
                                                      //     ),
                                                      //     permission?.delete == 1 && (
                                                      //       <MenuItem key="view" onClick={() => viewItem(row.original.id)}>
                                                      //         View
                                                      //       </MenuItem>
                                                      //     ),
                                                      //     permission?.delete == 1 && (
                                                      //       <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                      //         Delete
                                                      //       </MenuItem>
                                                      //     ),
                                                      //   ]}
                                                      />
                                          </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                  
                                  </div>                                
                                
                                </div>                             
                            </div>
                            </div>
                        </div>
                        </div>
                    </section>
                    
                  </div>
            )}
           
        </div>
      </div>
    </div>
  );
};
export default DecaySale;
